<template>
  <k-panel class="ks-floating-menu">
    <template #title><div @click="show = !show">{{instance.title}}</div></template>
    <template #buttons>
      <k-btn size="m" icon @click="show = !show">
        <k-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</k-icon>
      </k-btn>
    </template>
    <template #default>
      <div v-if="show && !is_empty">
        <h3>Video</h3>
        <k-layout>
          <k-flex c6 class="pa-2">Input mode</k-flex>
          <k-flex c6 class="pa-2">{{video_input_mode}}</k-flex>
        </k-layout>
        <k-layout>
          <k-flex c6 class="pa-2">Output mode</k-flex>
          <k-flex c6 class="pa-2">
            <k-autocomplete
              :items="available_video_modes"
              :value="video_output_mode"
              @change="change_video_output_mode"
              hide-details
              single-line
              height="20"
              class="pa-0 ma-0"
              item-text="name"
              item-value="value">
            </k-autocomplete>
          </k-flex>
        </k-layout>
        <k-divider class="mt-3 mb-3"></k-divider>
        <h3>Audio</h3>
        <k-layout>
          <k-flex c6 class="pa-2">Output</k-flex>
          <k-flex c6 class="pa-2">Input</k-flex>
        </k-layout>
        <template v-for="ch in audio_output_channels">
          <k-layout>
            <k-flex c6 class="pa-2">{{ch.name}}</k-flex>
            <k-flex c6 class="pa-2">
              <k-autocomplete
                :items="audio_input_channels"
                :value="get_audio_channel(ch.value)"
                @change="change_audio_channel($event, ch.value)"
                hide-details
                single-line
                height="20"
                class="pa-0 ma-0"
                item-text="name"
                item-value="value">
              </k-autocomplete>
            </k-flex>
          </k-layout>
        </template>
      </div>
    </template>
  </k-panel>
</template>

<script>
import naturalSort from 'natural-sort'
import InstanceModel from '@/models/instance.js'

_.mixin({
  sortWith : function(arr, customFn) {
    return _.map(arr).sort(customFn)
  }
});

export default {
  props: ['id'],
  data () {
    var ch = this.$cloudserver.channel("instances:status:"+this.id);
    return {
      show: false,
      available_video_modes: [
        {name: "1080p50", value: "1080p50"},
        {name: "1080i50", value: "1080i50"}
      ],
      audio_input_channels: [
        {name: "Input ch 1", value: "AudioIn1"},
        {name: "Input ch 2", value: "AudioIn2"},
        {name: "Input ch 3", value: "AudioIn3"},
        {name: "Input ch 4", value: "AudioIn4"},
        {name: "Input ch 5", value: "AudioIn5"},
        {name: "Input ch 6", value: "AudioIn6"},
        {name: "Input ch 7", value: "AudioIn7"},
        {name: "Input ch 8", value: "AudioIn8"}
      ],
      audio_output_channels: [
        {name: "Output ch 1", value: "AudioOut0"},
        {name: "Output ch 2", value: "AudioOut1"},
        {name: "Output ch 3", value: "AudioOut2"},
        {name: "Output ch 4", value: "AudioOut3"},
        {name: "Output ch 5", value: "AudioOut4"},
        {name: "Output ch 6", value: "AudioOut5"},
        {name: "Output ch 7", value: "AudioOut6"},
        {name: "Output ch 8", value: "AudioOut7"}
      ],
      ws_channel: ch
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    instance () {
			return InstanceModel.instance_by_id(this.id);
		},
    settings() {
      return _.get(this.ws_channel.data, "instance", {})
    },
    is_empty() {
      return _.isEmpty(this.settings);
    },
    video_output_mode () {
      return _.get(this.settings, ["video_output", "Video mode"])
    },
    video_input_mode () {
      return _.get(this.settings, ["video_input", "Video mode"])
    },
    audio () {
      return _.get(this.settings, "audio")
    }
  },
  methods: {
    get_audio_channel (out_ch) {
      return _.get(this.audio, out_ch);
    },
    sort_values(values) {
      return _(values).toPairs().sortWith(naturalSort()).fromPairs().value();
    },
    change_video_output_mode (mode) {
      InstanceModel.send_command_to_external_device(this.instance, "change-setting", {name: "video_output", key: "Video mode", value: mode}, () => {}, () => {});
    },
    change_audio_channel (in_ch, out_ch) {
      InstanceModel.send_command_to_external_device(this.instance, "change-setting", {name: "audio", key: out_ch, value: in_ch}, () => {}, () => {});
    }
  }
}
</script>
